import {
    createApp
} from 'vue'
import '@/assets/css/app.css'
import App from './App.vue'
import './assets/tailwind.css'

createApp(App).mount('#app')